import { Injectable } from '@angular/core';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private isLoading = false;
  private isLoadingAlt = false;
  constructor(
  ) { }

  dismiss() {
    if(this.isLoading) {
      $('.loading_wrapper.init').remove();
      this.isLoading = false;
    }
  }

  loadingShow(loader?: string, message?: string) {
    if(!this.isLoading) {
      // console.log('loading');
      let default_loader = '<div class="loads-ellipsis"><div></div><div></div><div></div><div></div></div>';
      if(loader && loader == 'loading_2'){
        loader = '<div class="loadingio-spinner-dual-ball"><div class="ldio-dualball"><div></div><div></div><div></div></div></div>';
      } else {
        loader = loader ? loader : default_loader;
      }
      $('body').append(`<div class="loading_wrapper init"><div class="backdrop_loading"></div><div class="loading__content">${loader}<p>${message || 'Cargando...'}</p></div></div>`);
      this.isLoading = true;
      // setTimeout(() => {
      //   if(this.isLoading) {
      //     $('.loading_wrapper.init').remove();
      //     this.isLoading = false;
      //   }
      // }, 10000);
    }
  }

  dismissAlt() {
    if(this.isLoadingAlt) {
      $('.loading_wrapper.alt').remove();
      this.isLoadingAlt = false;
    }
  }

  loadingShowAlt(loader?: string, message?: string) {
    if(!this.isLoadingAlt) {
      // console.log('loading');
      let default_loader = '<div class="loads-ellipsis"><div></div><div></div><div></div><div></div></div>';
      if(loader && loader == 'loading_2'){
        loader = '<div class="loadingio-spinner-dual-ball"><div class="ldio-dualball"><div></div><div></div><div></div></div></div>';
      } else {
        loader = loader ? loader : default_loader;
      }
      $('body').append(`<div class="loading_wrapper alt"><div class="backdrop_loading"></div><div class="loading__content">${loader}<p>${message || 'Cargando...'}</p></div></div>`);
      this.isLoadingAlt = true;
      // setTimeout(() => {
      //   if(this.isLoadingAlt) {
      //     $('.loading_wrapper.alt').remove();
      //     this.isLoadingAlt = false;
      //   }
      // }, 10000);
    }
  }
}
